<template>
  <div class="action-buttons">
    <a-button
      v-if="availableProductsList.includes(productName)"
      class="view-button"
      type="primary"
    >
      <router-link
        active-class=""
        exact-active-class=""
        :to="getRouterLink(productName)"
      >
        {{ $t('home.viewDetail' /* 查看详情 */) }}
      </router-link>
    </a-button>
    <a-button
      v-if="[STATE.LAUNCH, STATE.TRIAL].includes(currentState)"
      class="trial-button"
      @click="handleTrialBtnClick(btnData)"
    >
      <template v-if="currentState === STATE.LAUNCH">
        <a
          v-if="/^http(s?):\/\//i.test(btnData.url)"
          :href="resolveExternalURL(btnData.url)"
          target="_blank"
        >
          {{ btnText }}
        </a>
        <router-link v-else :to="{ path: resolveInternalPath(btnData.url) }">
          {{ btnText }}
        </router-link>
      </template>
      <div v-else :class="{ 'is-disabled': currentState === STATE.NOT_FOUND }">
        {{ btnText }}
      </div>
    </a-button>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from "lodash";
import { mapGetters, mapState } from "vuex";
import { dirList } from "@/views/portal/products/data";

const STATE = {
  NOT_FOUND: 0, // 所有产品列表均未找到
  TRIAL: 1, // 只在所有产品列表找到
  LAUNCH: 2 // 在授权产品列表中找到
};
export default {
  name: "ActionButtons",
  inject: ["activeApplyTrial"],
  props: {
    productName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // 可用的产品数据列表
      availableProductsList: dirList,
      STATE,
      currentState: STATE.NOT_FOUND,
      btnData: null
    };
  },
  computed: {
    ...mapState("portal", ["authProducts", "productsData", "solutionsData"]),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    ...mapGetters(["user"]),
    btnText() {
      let result = this.$t('home.Comingsoon' /* 即将上线，敬请期待 */);
      switch (this.currentState) {
        case STATE.LAUNCH:
          result = this.$t('home.Enter' /* 进入产品 */);
          break;
        case STATE.TRIAL:
          result = this.$t('home.Applyfortrial' /* 申请试用 */);
          break;
      }
      return result;
    }
  },
  watch: {
    authProducts: {
      handler() {
        this.initProductsData();
      },
      deep: true
    }
  },
  mounted() {
    this.initProductsData();
  },
  methods: {
    getRouterLink(name) {
      return {
        name: "Products",
        query: {
          page: name
        }
      };
    },
    resolveInternalPath(path) {
      // 内部链接去掉端口号
      return path.trim().replace(/:\d+$/, "");
    },
    resolveExternalURL(url) {
      // 外部链接拼接 token 进行鉴权
      const token = this.$store.state.user.token;
      const joint = url.indexOf("?") > -1 ? "&" : "?";
      return `${url.trim()}${joint}token=${token}`;
    },
    initProductsData() {
      const findTargetProduct = (list = [], target) => {
        let found = null;
        for (const item of list) {
          if (found !== null) break;
          if (Array.isArray(item.children) && item.children.length) {
            if ((found = findTargetProduct(item.children, target)) !== null) {
              break;
            }
          } else {
            for (const _item of item.productList || []) {
              // productName 匹配目标值，且 status 为 1
              if ((_item.productName === target || _item.productName_zh_CN === target) && _item.status === 1) {
                found = _item;
                break;
              }
            }
          }
        }
        return found;
      };
      const { authProducts, productsData } = this;
      if (productsData && authProducts) {
        // 获取目标产品名，若 props 没有指定产品名，则取当前页面的名字做产品名
        const productName = this.productName || this.$route.query.page;
        // 查找目标产品数据并更新指定的按钮状态
        if (
          (this.btnData = cloneDeep(
            findTargetProduct(authProducts, productName)
          )) !== null
        ) {
          this.currentState = STATE.LAUNCH;
        } else if (
          (this.btnData = cloneDeep(
            findTargetProduct(productsData, productName)
          )) !== null
        ) {
          this.currentState = STATE.TRIAL;
        } else {
          this.currentState = STATE.NOT_FOUND;
        }
      }
    },
    handleTrialBtnClick(subItem) {
      if (isEmpty(this.user)) {
        this.activeApplyTrial();
      } else {
        this.$parent.$parent.dialogVisible = true;
        this.$parent.$parent.applyProduct = subItem;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.action-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  .view-button,
  .trial-button {
    display: flex;
    align-items: center;
    height: 30px;
    padding: 0 15px;
    font-size: 12px;
    line-height: 1;
  }
}
</style>
